// @flow
export function isMicrosoftEdge() {
    const ua = (global.navigator && global.navigator.userAgent) || '';
    const edge = ua.indexOf('Edge/');
    if (edge > 0) {
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    return false;
}



// WEBPACK FOOTER //
// ./src/core/utils/browser.js